export const activityTypes = {
  APPLICATION: 'APPLICATION',
  FERTILITY_APPLICATION: 'FERTILITY_APPLICATION',
  HARVEST: 'HARVEST',
  PLANTING: 'PLANTING'
};

export const SEASONS_ACRONYMS = {
  SPRING: 'SPR',
  SUMMER: 'SUM',
  FALL: 'FAL',
  WINTER: 'WNT',
  SAFRINHA: 'SAF'
};